/** Small dev/demo panel shown while the final-countdown preview is active (?preview=final or Ctrl+Shift+F). */
export default function PreviewControls({ t, onBuy, onJump, onExit }: { t: number; onBuy: () => void; onJump: (s: number) => void; onExit: () => void }) {
  return (
    <div className="holo-preview-ctl" role="region" aria-label="Final countdown preview controls">
      <div className="lbl">Preview · final countdown <span className="mono">(local only)</span></div>
      <div className="row">
        <button type="button" className="holo-btn ghost sm" onClick={() => onJump(300)}>5:00</button>
        <button type="button" className="holo-btn ghost sm" onClick={() => onJump(150)}>2:30</button>
        <button type="button" className="holo-btn ghost sm" onClick={() => onJump(60)}>1:00</button>
        <button type="button" className="holo-btn ghost sm" onClick={() => onJump(12)}>0:12</button>
      </div>
      <div className="row">
        <button type="button" className="holo-btn pri sm" onClick={onBuy}>Simulate key +30s</button>
        <button type="button" className="holo-btn ghost sm" onClick={onExit}>Exit</button>
      </div>
      <div className="mono hint">t = {t}s · loops at 0 · no contract calls</div>
    </div>
  );
}
